import { getAllFilterTitles } from 'components/DataExpansionComponents/Common/commonColumnHelpers'
import { FilterIdentifier } from '../../models/saved_view'
import { COMMON_COLUMNS } from 'components/DataExpansionComponents/Common/CommonColumnsInfo'
import { UNIVERSITY_COLUMNS } from 'components/DataExpansionComponents/Universities/universityColumnsInfo'
import { K12_COLUMNS } from 'components/DataExpansionComponents/K12/K12ColumnsInfo'
import { HOSPITAL_COLUMNS } from 'components/DataExpansionComponents/Hospitals/hospitalColumnsInfo'
import { NURSING_HOME_COLUMNS } from 'components/DataExpansionComponents/NursingHomes/nursingHomeColumnsInfo'
import { CHAIN_COLUMNS } from 'components/DataExpansionComponents/Chains/chainColumnsInfo'
import { DOORS_COLUMNS } from 'components/DataExpansionComponents/Doors/doorsColumnsInfo'
import { CONTACTS_COLUMNS } from 'components/Tables/ContactsTable/contactsColumnInfo'
import { COMPANIES_COLUMNS } from 'components/Tables/CompaniesTable/companiesColumnInfo'
import {
  DEAL_COLUMNS,
  DEAL_REPORT_COLUMNS,
} from 'components/DataExpansionComponents/Deals/dealsColumnInfo'
import { ACTIVITY_V2_COLUMNS } from 'components/DataExpansionComponents/Activity/activityV2ColumnInfo'
import { DEALS_PIPELINE_COLUMNS } from 'components/DataExpansionComponents/Deals/dealsPipelineColumnInfo'
import { CAMPAIGNS_COLUMNS } from 'features/campaigns/campaignsColumns'
import { EMAILS_COLUMNS } from 'components/Tables/EmailsTable/emailsColumnInfo'
import { REBATE_OFFERS_COLUMNS } from 'features/tradespend/rebateOffersColumnInfo'
import { REBATE_CLAIMS_COLUMNS } from 'features/tradespend/rebateClaimsColumnInfo'
import { LODGING_COLUMNS } from 'components/DataExpansionComponents/GooglePlaces/Lodging/LodgingColumnsInfo'
import { LODGING_DOORS_COLUMNS } from 'components/DataExpansionComponents/GooglePlaces/LodgingDoors/LodgingDoorsColumnsInfo'
import { CONTACT_REQUESTS_COLUMNS } from 'components/Tables/ContactRequestsTable/contactRequestsColumnInfo'
import { ATTRIBUTION_CODES_COLUMNS } from 'features/tradespend/attributionCodesColumnInfo'
import { REBATE_ENROLLMENT_COLUMNS } from 'features/tradespend/enrollments/rebateEnrollmentsColumnInfo'
import { CONVENIENCE_COLUMNS } from 'components/DataExpansionComponents/GooglePlaces/Convenience/ConvenienceColumnsInfo'
import { CONVENIENCE_DOORS_COLUMNS } from 'components/DataExpansionComponents/GooglePlaces/ConvenienceDoors/ConvenienceDoorsColumnsInfo'
import { NOTES_COLUMNS } from '../Tables/NotesTable/notesColumnInfo'
import { SELECT_LOCATIONS } from 'components/Tables/SelectLocationsForDealTable/selectLocationsForDealColumnInfo'
import { UNMATCHED_DOORS_COLUMNS } from 'components/DataExpansionComponents/UnmatchedDoors/UnmatchedDoorsColumnsInfo'
import { REMINDERS_COLUMNS } from '../Reminders/RemindersColumnsInfo'
import { PRODUCTS_COLUMNS } from 'components/Tables/ProductTable/productsColumnInfo'
import { VARIANTS_COLUMNS } from 'components/Tables/VariantSearchTable/variantsColumnInfo'

const allCommonFilterTitles: Record<string, string> = {
  ...getAllFilterTitles({ columns: COMMON_COLUMNS }),
}

const originalFilterTitles: Record<FilterIdentifier, Record<string, string>> = {
  CNU_TABLE: {
    ...allCommonFilterTitles,
    ...getAllFilterTitles({ columns: UNIVERSITY_COLUMNS }),
  },
  K12_TABLE: {
    ...allCommonFilterTitles,
    ...getAllFilterTitles({ columns: K12_COLUMNS }),
  },
  DOORS_TABLE: {
    ...allCommonFilterTitles,
    ...getAllFilterTitles({ columns: DOORS_COLUMNS }),
  },
  DEALS_TABLE: {
    ...allCommonFilterTitles,
    ...getAllFilterTitles({ columns: DEAL_COLUMNS }),
  },
  REPORT_DEALS_TABLE: {
    ...allCommonFilterTitles,
    ...getAllFilterTitles({ columns: DEAL_REPORT_COLUMNS }),
  },
  DEALS_PIPELINE_TABLE: {
    ...allCommonFilterTitles,
    ...getAllFilterTitles({ columns: DEALS_PIPELINE_COLUMNS }),
  },
  CONTACTS_TABLE: {
    ...allCommonFilterTitles,
    ...getAllFilterTitles({ columns: CONTACTS_COLUMNS }),
  },
  COMPANIES_TABLE: {
    ...allCommonFilterTitles,
    ...getAllFilterTitles({ columns: COMPANIES_COLUMNS }),
  },
  CHAINS_TABLE: {
    ...allCommonFilterTitles,
    ...getAllFilterTitles({ columns: CHAIN_COLUMNS }),
  },
  ACTIVITY_TABLE_V2: {
    ...getAllFilterTitles({ columns: ACTIVITY_V2_COLUMNS }),
  },
  HOSPITAL_TABLE: {
    ...allCommonFilterTitles,
    ...getAllFilterTitles({ columns: HOSPITAL_COLUMNS }),
  },
  NURSING_HOME_TABLE: {
    ...allCommonFilterTitles,
    ...getAllFilterTitles({ columns: NURSING_HOME_COLUMNS }),
  },
  ALL_CAMPAIGNS_TABLE: {
    ...allCommonFilterTitles,
    ...getAllFilterTitles({ columns: CAMPAIGNS_COLUMNS }),
  },
  EMAILS_TABLE: {
    ...allCommonFilterTitles,
    ...getAllFilterTitles({ columns: EMAILS_COLUMNS }),
  },
  REBATES_TABLE: {
    ...allCommonFilterTitles,
    ...getAllFilterTitles({ columns: REBATE_OFFERS_COLUMNS }),
  },
  REBATE_CLAIMS_TABLE: {
    ...allCommonFilterTitles,
    ...getAllFilterTitles({ columns: REBATE_CLAIMS_COLUMNS }),
  },
  LODGING_TABLE: {
    ...allCommonFilterTitles,
    ...getAllFilterTitles({ columns: LODGING_COLUMNS }),
  },
  LODGING_DOOR_TABLE: {
    ...allCommonFilterTitles,
    ...getAllFilterTitles({ columns: LODGING_DOORS_COLUMNS }),
    taglist: 'Chain Tags',
    distributors: 'Chain Distributors',
  },
  CONTACT_REQUESTS_TABLE: {
    ...allCommonFilterTitles,
    ...getAllFilterTitles({ columns: CONTACT_REQUESTS_COLUMNS }),
  },
  ATTRIBUTION_CODES_TABLE: {
    ...allCommonFilterTitles,
    ...getAllFilterTitles({ columns: ATTRIBUTION_CODES_COLUMNS }),
  },
  REBATE_ENROLLMENTS_TABLE: {
    ...allCommonFilterTitles,
    ...getAllFilterTitles({ columns: REBATE_ENROLLMENT_COLUMNS }),
  },
  CONVENIENCE_TABLE: {
    ...allCommonFilterTitles,
    ...getAllFilterTitles({ columns: CONVENIENCE_COLUMNS }),
  },
  CONVENIENCE_DOOR_TABLE: {
    ...allCommonFilterTitles,
    ...getAllFilterTitles({ columns: CONVENIENCE_DOORS_COLUMNS }),
    taglist: 'Chain Tags',
    distributors: 'Chain Distributors',
  },
  NOTES_TABLE: {
    ...allCommonFilterTitles,
    ...getAllFilterTitles({ columns: NOTES_COLUMNS }),
  },
  DOOR_NOTES_TABLE: {
    ...allCommonFilterTitles,
    ...getAllFilterTitles({ columns: NOTES_COLUMNS }),
  },
  SELECT_LOCATIONS: {
    ...allCommonFilterTitles,
    ...getAllFilterTitles({ columns: SELECT_LOCATIONS }),
  },
  UNMATCHED_DOORS_TABLE: {
    ...allCommonFilterTitles,
    ...getAllFilterTitles({ columns: UNMATCHED_DOORS_COLUMNS }),
  },
  REMINDERS_TABLE: {
    ...allCommonFilterTitles,
    ...getAllFilterTitles({ columns: REMINDERS_COLUMNS }),
  },
  PRODUCTS_TABLE: {
    ...allCommonFilterTitles,
    ...getAllFilterTitles({ columns: PRODUCTS_COLUMNS }),
  },
  VARIANTS_TABLE: {
    ...allCommonFilterTitles,
    ...getAllFilterTitles({ columns: VARIANTS_COLUMNS }),
  },
  AUTOMATIONS_TABLE: {
    // No filters, only search
  },
  DOCUMENTS_TEAM_TABLE: {
    // TODO (FIR-4391): Add document filter columns when filtering is implemented
  },
  DOCUMENTS_PRODUCT_TABLE: {
    // TODO (FIR-4391): Add document filter columns when filtering is implemented
  },
  DOCUMENTS_COMPANY_TABLE: {
    // TODO (FIR-4391): Add document filter columns when filtering is implemented
  },
  DOCUMENTS_MODAL: {
    // No filters needed for modal view
  },
  MY_SAMPLES_TABLE: {
    // Samples filter titles (not implemented here yet)
  },
  SAMPLES_TABLE: {
    // Samples filter titles (not implemented here yet)
  },
}

export const FILTER_TITLES = new Proxy(originalFilterTitles as any, {
  get(target, prop: string) {
    if (prop.startsWith('companies-')) {
      return target['COMPANIES_TABLE']
    }
    if (prop.startsWith('CHAINS_TABLE')) {
      return target['CHAINS_TABLE']
    }
    if (prop.startsWith('DOORS_TABLE')) {
      return target['DOORS_TABLE']
    }
    if (prop.startsWith('DEALS_TABLE')) {
      return target['DEALS_TABLE']
    }
    if (prop.startsWith('CNU_TABLE')) {
      return target['CNU_TABLE']
    }
    if (prop.startsWith('K12_TABLE')) {
      return target['K12_TABLE']
    }
    if (prop.startsWith('CONTACTS_TABLE')) {
      return target['CONTACTS_TABLE']
    }
    if (prop.startsWith('HOSPITAL_TABLE')) {
      return target['HOSPITAL_TABLE']
    }
    if (prop.startsWith('NURSING_HOME_TABLE')) {
      return target['NURSING_HOME_TABLE']
    }
    if (prop.startsWith('ALL_CAMPAIGNS_TABLE')) {
      return target['ALL_CAMPAIGNS_TABLE']
    }
    if (prop.startsWith('EMAILS_TABLE')) {
      return target['EMAILS_TABLE']
    }
    if (prop.startsWith('LODGING_TABLE')) {
      return target['LODGING_TABLE']
    }
    if (prop.startsWith('LODGING_DOOR_TABLE')) {
      return target['LODGING_DOOR_TABLE']
    }
    if (prop.startsWith('CONTACT_REQUESTS_TABLE')) {
      return target['CONTACT_REQUESTS_TABLE']
    }
    if (prop.startsWith('ATTRIBUTION_CODES_TABLE')) {
      return target['ATTRIBUTION_CODES_TABLE']
    }
    if (prop.startsWith('CONVENIENCE_TABLE')) {
      return target['CONVENIENCE_TABLE']
    }
    if (prop.startsWith('CONVENIENCE_DOOR_TABLE')) {
      return target['CONVENIENCE_DOOR_TABLE']
    }
    if (prop.startsWith('NOTES_TABLE')) {
      return target['NOTES_TABLE']
    }
    if (prop.startsWith('SELECT_LOCATIONS')) {
      return target['SELECT_LOCATIONS']
    }
    if (prop.startsWith('UNMATCHED_DOORS_TABLE')) {
      return target['UNMATCHED_DOORS_TABLE']
    }
    if (prop.startsWith('REMINDERS_TABLE')) {
      return target['REMINDERS_TABLE']
    }
    return target[prop as keyof typeof target]
  },
})
